import { FC } from 'react';
import Avatar from '@strawberrylemonade/boring-avatars';
import { AvatarImage } from './avatar/AvatarImage';
import { useAvatarImage } from './avatar/useAvatarImage';

interface AvatarProps {
  name?: string;
  src?: string | null;
  variant?: 'marble' | 'beam' | 'pixel' | 'sunset' | 'ring' | 'bauhaus';
  size?: number;
  greyscale?: boolean;
}

export const TimeshiftAvatar: FC<AvatarProps> = ({ name, src, greyscale, variant = 'beam', size = 70 }) => {
  const initials = name
    ?.match(/\b([A-Z])/g)
    ?.join('')
    .toUpperCase();
  const { resolvedSrc, canRenderImage, handleImageError } = useAvatarImage(src);

  return (
    <span className={greyscale ? 'filter grayscale' : ''}>
      {resolvedSrc && canRenderImage ? (
        <AvatarImage
          alt={name ?? 'Employee avatar'}
          className="rounded-full object-cover"
          onError={handleImageError}
          size={size}
          src={resolvedSrc}
        />
      ) : (
        <Avatar
          name={initials}
          colors={[
            'var(--primary-color-700)',
            'var(--primary-color-500)',
            'var(--primary-color-800)',
            'var(--secondary-color-600)',
            'var(--secondary-color-600)'
          ]}
          size={size}
          variant={variant}
        />
      )}
    </span>
  );
};
